//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 22.07.2015.
 */

(function () {

    'use strict';

    angular.module('container.layout')
        .directive('srsngTabBar', srsngTabBar);

    function srsngTabBar($rootScope, tabBarService, $timeout) {

        return {
            restrict: 'E',
            scope: {},
            templateUrl: 'container/ui/app/layout/tab-bar/tab-bar.html',
            controller: controller,
            link: link
        };

        function controller($scope, $rootScope, tabBarService, $compile, $injector, $parse, $state, $location) {

            $scope.tabLimit = 20;
            $scope.overflowMenu = {
                visible: false
            };

            $scope.visibleTabs = [];
            $scope.overflowTabs = [];


            $scope.toggleOverflowMenu = function ($event) {

                if (!$scope.hasOverflow())
                    return;

                $scope.overflowMenu.visible = !$scope.overflowMenu.visible;
                $event.stopPropagation();
            };

            $scope.toggleTabMenu = function (tab) {

                tab.menuVisible = !tab.menuVisible;
            };

            $scope.closeTab = function (tab, event) {
                tabBarService.removeTab(tab.id);
                event.preventDefault();
                event.stopImmediatePropagation();
                return true;
            };

            $scope.moveTabToFront = function ($event, tab) {
                tabBarService.moveTab(tab.id, 0);
                $scope.toggleOverflowMenu($event);
                $state.go(tab.state, tab.params);
            };

            $scope.hasOverflow = function () {
                return $scope.overflowTabs.length > 0;
            };

            $scope.callMenuFunction = function (tab, expression) {

                var service = $injector.get(expression[0]);
                service[expression[1]].apply(service, expression[2]);
                tab.menuVisible = false;
            };

            $scope.isActiveState = function(state) {

                if( !state ) return false;

                state = state.replace("#", "");
                var location = $location.$$url;

                return state == location;
            }

            $rootScope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {

                let href  = '#' + $location.$$url;
                let activeTab = $scope.visibleTabs.find(tab=> tab.stateHref === href);
                if( activeTab ) return;
                activeTab = $scope.allTabs.find(tab=> tab.stateHref === href);
                if( !activeTab) return;
                //tabBarService.moveTab(activeTab.id, 0);

                $scope.moveTabToFront(event, activeTab);

            });
        }

        function link(scope, element, attrs) {

            scope.allTabs = [];

            $rootScope.$on('tabBarService:tabsChanged', updateTabs);

            window.addEventListener('resize', updateTabs);

            function updateTabs() {

                scope.allTabs =  tabBarService.getTabs();
                scope.visibleTabs = scope.allTabs.slice();

                var tabOverflowMenuButtonEl = element.find('#tab-overflow-menu-button');
                tabOverflowMenuButtonEl.removeClass("white blue");
                tabOverflowMenuButtonEl.addClass(scope.visibleTabs.length>0 ? "white" : "blue");


                $timeout(function () {

                      var visibleTabsElement = element.find('.visible-tabs');
                      var overflowMenuButtonWidth = parseInt(visibleTabsElement.find('.overflow-menu-button .content').css('min-width'), 10);
                      var maxWidth = visibleTabsElement.outerWidth() - overflowMenuButtonWidth;

                      var hiddenTabsElement = element.find('#hidden-tabs');
                      var rightX = 0;

                      var index = -1;
                      hiddenTabsElement.find('.tab').each(function(i, tab) {

                          rightX += tab.getBoundingClientRect().width;
                          if( rightX > maxWidth) {
                              index = i;
                              return false;
                          }
                      });

                      scope.visibleTabs = index >= 0  ? scope.allTabs.slice(0, index) : scope.allTabs.slice();
                      scope.overflowTabs = index >= 0 ? scope.allTabs.slice(index) : [];

                      tabBarService.setVisibleTabCount(scope.visibleTabs.length);
                });
            }

            updateTabs();
        }
    }
})();
